import(/* webpackMode: "eager" */ "/home/app/app/[locale]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/app/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatSubscriptionsProvider"] */ "/home/app/components/utility/chat-subscription-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChunkReload"] */ "/home/app/components/utility/chunk-reload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/home/app/components/utility/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalState"] */ "/home/app/components/utility/global-state.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/app/components/utility/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/components/utility/translations-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PermissionProvider"] */ "/home/app/context/permissionContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/home/app/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/home/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/app/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/app/node_modules/vanilla-jsoneditor/themes/jse-theme-dark.css");
;
import(/* webpackMode: "eager" */ "/home/app/whyDidYouRender.ts");
